module.exports = __webpack_public_path__ + "play-btn.png?dd8460ce0aa2fddb1efe9674ab845c5c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/play-btn.png
// module id = 188
// module chunks = 0